var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('picture',{staticClass:"main-bg"},[_c('img',{staticClass:"main-bg__img",attrs:{"src":require("@/assets/img/head-bg.jpg"),"alt":""}})])}]

export { render, staticRenderFns }